// src/index.tsx
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.css';

import App from './components/App';
import Header from './components/Header';
import About from './components/About';
import Projects from './components/Projects';
import YouTube from './components/Projects/YouTube';
import Kaboom from './components/Projects/Kaboom';
import SystemDesignCalculator from './components/Projects/SystemDesignCalculator';
import RunningPaceCalculator from './components/Projects/RunningPaceCalculator';
import Travel from './components/Projects/Travel';
import Contact from './components/Contact';
import './index.css';

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error('Failed to find the root element');

const root = ReactDOM.createRoot(rootElement);

root.render(
    <BrowserRouter>
        <Header/>
        <Routes>
            <Route path="/" element={<App />} />
            <Route path="/about" element={<About />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/projects/travel" element={<Travel />} />
            <Route path="/projects/youtube" element={<YouTube />} />
            <Route path="/projects/kaboom" element={<Kaboom />} />
            <Route path="/projects/system-design-calculator" element={<SystemDesignCalculator />} />
            <Route path="/projects/running-pace-calculator" element={<RunningPaceCalculator />} />
            <Route path="/contact" element={<Contact />} />
        </Routes>
    </BrowserRouter>
);

